import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SAVE_FILTER_QUERY_KEY } from "../types/CommonTypes";
import { queryClient } from "../../../utils/ReactQueryConfig";

async function deleteSavedFilter(
  tenantId: string,
  hospitalId: string,
  filterId: string
): Promise<any> {
  const { data } = await fetcher({
    url: `/hospital/custom-filters/${filterId}`,
    method: "DELETE",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useDeleteSavedFilterMutation(
  tenantId?: string,
  hospitalId?: string
) {
  return useMutation({
    mutationFn: (filterId: string) =>
      deleteSavedFilter(tenantId!, hospitalId!, filterId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SAVE_FILTER_QUERY_KEY, hospitalId, tenantId],
      });
    },
  });
}
